import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ToastContainer from 'sushiweb/ToastContainer';
import App from './App';
import { initialiseLoginSDKs } from './helpers';
import store from './store';
import './index.css';

initialiseLoginSDKs();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ToastContainer>
      <App />
    </ToastContainer>
  </Provider>,
);
